<div class="control back" (click)="previous()">
  <img src="/assets/addict/mobile/Colors/arrow%20L.svg"/>
</div>
<img class="picture" [src]="selectedImage"/>
<div class="control next" (click)="next()">
  <img src="/assets/addict/mobile/Colors/arrow%20R.svg"/>
</div>
